import BreadCrump from '../tools/breadcrump';
import * as React from 'react';
import { useParams } from 'react-router-dom';
import { config } from "../../data/config";
import { useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { useState } from "react";
import ImageUploader from '../tools/uploaderImage';
import axios from 'axios';
import { getCookies } from "cookies-next";
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import HeaderOfPage from '../tools/headerOfPage';
import { TextField } from '@mui/material';
export default function SettingPage() {
    const { t } = useTranslation();

    const [data, setData] = React.useState<any>(null);
    const [key, setKey] = useState<any>(1);
    const [error, setError] = useState<any>(null);
    let cookie = getCookies();

    const inputstyle = "py-3 px-5 block w-full border-gray-499 rounded text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none shadow";
    const breadcrump = [
        {
            name: 'Dashboard',
            url: '/dashboard'
        },

        {
            name: 'Setting',
            url: '/dashboard/setting'
        },
        {
            name: 'General',
            url: null
        },
    ]
    const load = async () => {
        try {
            var path = `${config.url}/v1/dashboard/setting`;

            let res = await axios({
                method: 'get',
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            setData(res.data.message)
        } catch (error) {

        }
    }
    const save = async () => {
        try {
            var path = `${config.url}/v1/dashboard/setting/${data.id}`;

            let res = await axios({
                method: 'put',
                data: data,
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            Swal.fire(t('Saved'));
        } catch (error) {

        }
    }
    useEffect(() => {
        load();
    }, []);
    return (
        <div className='directions bg-slate-100'>
            <div className="text-left    p-3 m-4   min-h-[100vh] mb-5 ">


                <BreadCrump data={breadcrump}></BreadCrump>
                <HeaderOfPage name="General Setting"></HeaderOfPage>

             
                {
                    data != null && <div className='grid grid-cols-2 p-4 gap-3  ' dir='rtl'>
                        <div>
                            <form key={key} className='flex flex-col gap-2'>
                                <div className=" space-y-3 text-start">
                                    <label className="text-start">{t('website Name')}   </label>
                                    <input

                                        defaultValue={data.name}
                                        type="text"
                                        className={`${inputstyle}  shadow    ${error != null && error['name'] != undefined && `bg-red-100`} `}
                                        placeholder="Name"
                                        onChange={(e) => setData({ ...data, name: e.target.value })}
                                    />
                                    {error != null && error['url'] != undefined && <small>{error['name']['message']}</small>}
                                </div>
                                <div className=" space-y-3 text-start" dir='rtl'>
                                    <label className="">{t('Title')}   </label>
                                    <textarea
                                        defaultValue={data.title}
                                        className={`${inputstyle}  shadow    ${error != null && error['name'] != undefined && `bg-red-100`} `}
                                        placeholder="Title"
                                        onChange={(e) => setData({ ...data, title: e.target.value })}
                                    />
                                    {error != null && error['url'] != undefined && <small>{error['name']['message']}</small>}
                                </div>
                                <div className=" space-y-3 text-start" dir='rtl'>
                                    <label className="">{t(' Alt لوگو')}   </label>
                                    <textarea

                                        defaultValue={data.altlogo}
                                        className={`${inputstyle}  shadow    ${error != null && error['name'] != undefined && `bg-red-100`} `}
                                        onChange={(e) => setData({ ...data, altlogo: e.target.value })}
                                    />
                                    {error != null && error['url'] != undefined && <small>{error['name']['message']}</small>}
                                </div>
                                <div className=" space-y-3 mt-4 text-start">
                                    <label className="">{t('Keywords')}   </label>
                                    <textarea
                                        defaultValue={data.keywords}

                            rows={12}
                                        className={inputstyle}
                                        onChange={(e) => setData({ ...data, keywords: e.target.value })}
                                        placeholder="..." />
                                </div>

                                <div className=" space-y-3 mt-4 text-start">
                                    <label className=""> {t('Description')}   </label>
                                    <textarea
                                        defaultValue={data.description}
                                        rows={12}
                                        className={inputstyle}
                                        onChange={(e) => setData({ ...data, description: e.target.value })}
                                        placeholder="..." />
                                    <button
                                        onClick={(e) => { save() }}
                                        type="button" className="py-3 px-4
                                     items-center gap-x-2 text-sm font-medium rounded-full border 
                                     border-transparent bg-gray-700 text-white hover:bg-blue-700 
                                     w-[100%]
                                     focus:outline-none focus:bg-blue-700 disabled:opacity-50  text-center m-auto 
                                     disabled:pointer-events-none">
                                        {t('Save')}
                                    </button>
                                </div>
                                <div className=' '>

                                </div>
                            </form>
                        </div>

                        {data != null && <div>
                            <div className='directions text-start'>   {t('Logo Upload')} </div>
                            <hr />
                            <ImageUploader id={data.id} component={'Post'}></ImageUploader>

                        </div>}


                    </div>
                }


            </div>

        </div>
    )
}